"use strict";

 require('./campaign_broadcast_block');
 require('./campaign-schedule-day');

angular.module('rmCampaign')
	.directive('campaignfocus',['$document', function ($document) {
	return {
		restrict: 'A',
		link: function (scope, element, attrs) {
			let toolbar = attrs['campaignfocus'];
			let editor = element.find('#editor-campaign');

			$document.on('mousedown', onClick);

			function onClick(event) {
				//checks if is clicked on element or a child of it
				let isChild = element.find(event.target).length > 0;
				let isSelf  = event.target == element;

				if(isChild || isSelf){
					$('#'+toolbar).show(150).focus();
					editor.addClass('ql-focused');
				}else{
					$('#'+toolbar).hide(150);
					editor.removeClass('ql-focused');
				}
			}

			scope.$on('$destroy', function() {
				$document.off('mousedown', onClick);
			});
		}
	}
}])
.directive("campaignscroll", ['$window','$timeout', function ($window, $timeout) {

	return function ($scope, element, attrs) {
		angular.element('md-tab-content > div').bind("scroll", function () {
			if(this.scrollTop >= 150) {
				element.addClass('fixed');
			} else if(element.hasClass('fixed')){
				element.removeClass('fixed');
			}

			$scope.$apply();
		});
	};
}])
.directive("blockscroll", ['$window','$timeout', function ($window, $timeout) {

	return function (scope, element, attrs) {

		let bar = element.closest('md-content');
		let tip = element.find('.campaign-tooltip');
		let top = scope.block._y;
		let h = (scope.block.campaigns_count.length ? 30 : 0 ) + (scope.block.campaigns_count.length*12) + 18;
		function onOver(e) {
			let x = bar.scrollTop();
			x += h;
			scope.block._y < x ? tip.addClass('tooltip-bottom') : tip.removeClass('tooltip-bottom');
		}

		element.on('mouseover', onOver);
		scope.$on('$destroy', () => {
			element.off('mouseover', onOver);
		});
	};
}]);
